// import { configureStore } from "@reduxjs/toolkit";

// import { apiSlice } from "./api/apiSlice";
// import authSliceReducer from "./auth/authSlice";
// import layoutSliceReducer from "./layout/layoutSlice";
// import ecommerceSliceReducer from "./ecommerce/ecommerceSlice";

// export const store = configureStore({
//   reducer: {
//     [apiSlice.reducerPath]: apiSlice.reducer,
//     auth: authSliceReducer,
//     layout: layoutSliceReducer,
//     ecommerce: ecommerceSliceReducer
//   },
//   devTools: process.env.NODE_ENV !== "production",
//   middleware: (getDefaultMiddlewares) => getDefaultMiddlewares().concat(apiSlice.middleware)
// });



import { configureStore } from "@reduxjs/toolkit";
import axiosInstance from "../services/axios";
import { apiSlice } from "./api/apiSlice";
import authSliceReducer from "./auth/authSlice";
import layoutSliceReducer from "./layout/layoutSlice";
import ecommerceSliceReducer from "./ecommerce/ecommerceSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSliceReducer,
    layout: layoutSliceReducer,
    ecommerce: ecommerceSliceReducer
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware)
});

// ✅ restore token after refresh
const token = localStorage.getItem("jwt_token");

if (token) {
  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}